import Cookies from "js-cookie";

/**
 * Efface le token de session et redirige vers la page d'accueil
 */
export const clearSessionAndRedirect = () => {
  // Supprimer le token des cookies
  Cookies.remove("token");

  // Rediriger vers la page d'accueil
  window.location.href = "/";
};

/**
 * Vérifie si l'utilisateur avait un token avant la suppression
 */
export const hadValidSession = (): boolean => {
  return !!Cookies.get("token");
};
